import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

/** Every open tab heartbeats /presence/ping every 30s so admins can see who's live. */
export function usePresenceHeartbeat() {
  const loc = useLocation();
  const timerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) return;

    // Session id lives in sessionStorage — one per tab.
    let sid;
    try {
      sid = sessionStorage.getItem("cq_presence_sid");
      if (!sid) {
        sid = "s-" + Math.random().toString(36).slice(2, 14) + "-" + Date.now().toString(36);
        sessionStorage.setItem("cq_presence_sid", sid);
      }
    } catch { sid = "s-" + Math.random().toString(36).slice(2, 14); }

    const ping = async () => {
      if (cancelled) return;
      try {
        const token = (() => { try { return localStorage.getItem("cq_token"); } catch { return null; } })();
        await axios.post(
          `${base}/api/presence/ping`,
          { session_id: sid, path: loc.pathname + (loc.search || "") },
          { headers: token ? { Authorization: `Bearer ${token}` } : {}, timeout: 5000 },
        );
      } catch { /* silent */ }
    };
    ping();
    timerRef.current = setInterval(ping, 30_000);
    // Immediate ping on visibility restore so counts stay accurate
    const onVis = () => { if (document.visibilityState === "visible") ping(); };
    document.addEventListener("visibilitychange", onVis);
    return () => {
      cancelled = true;
      if (timerRef.current) clearInterval(timerRef.current);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [loc.pathname, loc.search]);
}
